import { EqCurrency, EqOrderStatus, EqPaymentSourceType, EqPaymentStatus, ProductStatus, ProductType } from "../enums";
import { EqEntityUser } from "./IUserInfoDto";
import { IEqUserInfoDto } from "./ridingCourse/IRidingCourse";


export enum EqProductType {
    Public = 1,
    Private = 2
}
export enum ProductStatusEnum {
    Drafted = "Drafted",
    Active = "Active",
    Paused = "Paused",
     //Completed = "Completed",
     //Deleted = "Deleted",
     //Requested = "Requested"
}

// export enum EqCurrency {
//     NOK = "NOK", // Norwegian Krone
//     SEK = "SEK", // Swedish Krona
//     USD = "USD", // United States Dollar
//     EUR = "EUR"  // EURO
// }

// export enum EqOrderStatus {
//     // Define the possible values for EqOrderStatus here
//     // Example:
//     Pending = "Pending",
//     Completed = "Completed",
//     Cancelled = "Cancelled"
// }
export interface EqEntityProductOrderDto {
    id: string;
    productId: string;
    product: EqEntityProductDto;
    studentId: string;
    student: IEqUserInfoDto;
    status: EqOrderStatus;
    customPrice?: number;
    createdOn?: number;
}

export interface EqEntityProductDto {
    id: string;
    type: ProductType;
    limit: number;
    lessons?: number;
    individualPrice?: number;
    price: number;
    title: string;
    productNumber: string;
    description: string;
    vat: string;
    imageUrl?: string;
    currency?: EqCurrency;
    isUsed: boolean;
    isRequestRequired: boolean;
    userId: string;
    user?: IUsers;
    productOrders: EqEntityProductOrderDto[];
    availableSpace?: number;
    status: ProductStatus;
    number: number;
}
interface IUsers {
    id: string;
    key: number;
    firstName: string;
    lastName: string;
    companyName?: string | null;
    schoolName?: string | null;
    email: string;
    userName: string;
    phoneNumber: string;
    professionType: number;
    userImage?: string | null;
    allowLatePayments: boolean;
    cancellationDeadline: number;
    refundType?: any | null;
    allowProductTrainingCancel?: any | null;
    productRefundType?: any | null;
    horses: any[];
    groups: any[];
    paymentStatus?: any | null;

}

export interface IProductsList {
    all: EqEntityProductDto[];
    private: EqEntityProductDto[];
    public: EqEntityProductDto[];
    filteredList?: EqEntityProductDto[];
}


export interface IEqEntitySubscriptionProductDto {
    id: string; // Guid in C# maps to string in TypeScript
    name: string;
    description: string;
    price: number; // long in C# maps to number in TypeScript
}


export interface EqEntityProductPayment {
    id: string; // Guid becomes string in TypeScript
    orderId: string;
    order?: EqEntityProductOrder; // Optional if not always loaded
    paymentDate: number; // long becomes number
    status: EqPaymentStatus;
    paymentReminder: boolean;
    note: string;
    paymentSourceType: EqPaymentSourceType;
    stripePaymentIntentId?: string | null; // Nullable string
    refundAmount: number; // decimal becomes number
}


export interface EqEntityProduct {
    id: string; // Guid becomes string
    type: EqProductType;
    limit?: number | null; // Nullable long
    lessons?: number | null; // Nullable long
    individualPrice?: number | null; // Nullable long
    price: number; // long becomes number
    title: string;
    productNumber: string;
    description: string;
    vat: string;
    currency?: EqCurrency | null; // Nullable enum
    isUsed: boolean;
    isRequestRequired: boolean;
    
    // User relationship
    userId: string;
    user: EqEntityUser;
    
    // Image
    imageUrl?: string | null; // Nullable string
    
    // Orders
    productOrders: EqEntityProductOrder[]; // ICollection becomes array
    
    // Soft delete
    isDeleted: boolean;
    
    // Status
    status: ProductStatusEnum;
}

export interface EqEntityProductOrder {
    id: string;                   // Guid becomes string
    productId: string;
    product: EqEntityProduct;     // Defined below
    studentId: string;
    student: EqEntityUser;        // Defined below
    status: EqOrderStatus;
    payment?: EqEntityProductPayment | null;  // Optional payment
    customPrice?: number | null;  // Nullable long (number in TS)
    createdOn?: number | null;    // Nullable long (number in TS)
}
